"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGridFilterOptionsForExpressionEditorProps = void 0;
const AdaptableContext_1 = require("../AdaptableContext");
const useGridFilterOptionsForExpressionEditorProps = () => {
    const adaptable = (0, AdaptableContext_1.useAdaptable)();
    const gridFilterEditors = adaptable.api.optionsApi.getGridFilterOptions().availableFilterEditors;
    return {
        showQueryBuilder: gridFilterEditors.includes('QueryBuilder'),
        showExpressionEditor: gridFilterEditors.includes('ExpressionEditor'),
    };
};
exports.useGridFilterOptionsForExpressionEditorProps = useGridFilterOptionsForExpressionEditorProps;
